import { quesionService } from "./../services/Question.service";
import router from "../router/router";
import { MessageBox, Loading } from "element-ui";
const state = {
    tableData: [],
    current_faq: {},
    total: 0
};

const actions = {
    async searchQuestion({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await quesionService.searchQuestion(data);
        if (result.status === 200) {
            state.tableData = [];
            // for (var i = 0; i < result.data.length; i++) {
            //     result.data[i]["detail"] = result.data[i]
            // }
            state.tableData = result.data;
            state.total = result.data.length > 0 ? result.data[0].total : 0
            setTimeout(function() { loadingInstance.close() }, 250)
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async getQuestion({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await quesionService.getQuestion(data);
        if (result.status === 200) {
            state.current_faq = result.data[0]
            setTimeout(function() { loadingInstance.close() }, 250)
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async addQuestion({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await quesionService.addQuestion(data);
        if (result.status === 200) {
            // router.push({ name: "Manage_question" });
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_question' })
            }).catch(() => {
                router.push({ name: 'Manage_question' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async editQuestion({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await quesionService.editQuestion(data);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('แก้ไขข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_question' })
            }).catch(() => {
                router.push({ name: 'Manage_question' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async remove({ commit }, data) {
        let result = await quesionService.removeQuestion(data);
        if (result.status === 200) {
            MessageBox.confirm('ลบข้อมูลเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                // commit('CUT_TABLE', data)
            }).catch(() => {
                // commit('CUT_TABLE', data)
            });
        } else {
            MessageBox.confirm(result.message, "แจ้งเตือน", {
                    confirmButtonText: "ตกลง",
                    showCancelButton: false,
                    type: "warning"
                })
                .then(() => {})
                .catch(() => {});
        }
    }
};

const mutations = {
    CUT_TABLE(state, data) {
        let index = state.tableData.findIndex(x => x.faq_id === data);
        state.tableData.splice(index, 1);
    }
};

export const questionStore = {
    namespaced: true,
    state,
    actions,
    mutations
};